if (!customElements.get('aov-heading-savings')) {
  customElements.define('aov-heading-savings', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productInfo);
      if (!this.root) return;
      try { this.config = JSON.parse(this.querySelector('script').textContent); }
      catch { return; }
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['aria-checked', 'class', 'value']
      });
      this.root.addEventListener('change', this.schedule);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change', this.schedule);
      cancelAnimationFrame(this.frame);
    }

    update() {
      const offers = [...this.root.querySelectorAll('.Avada-VolumeItem__Container > .Avada-Volume__Item')];
      const index = offers.findIndex(offer => offer.querySelector('[aria-checked="true"]'));
      const tier = this.config.tiers[index];
      if (!tier || !['selling', 'compare'].includes(tier.basis)) return;
      const quantity = Number(tier.quantity);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      const variantId = this.root.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.config.initialVariant;
      const variant = this.config.variants.find(item => String(item.id) === String(variantId));
      const priceNode = offers[index].querySelector('.AOV-Offer__DiscountPrice');
      const total = priceNode && window.PetsUpsellOffers?.readMoney(priceNode.textContent, this.config.currency);
      const reference = Number(tier.basis === 'compare' ? variant?.compare : variant?.price) * quantity;
      if (!Number.isFinite(total) || total < 0 || !Number.isFinite(reference) || reference <= 0) return;
      const heading = this.root.querySelector('.product-page-price .price');
      const compare = heading?.querySelector('.price__compare-price s');
      const badge = heading?.querySelector('.price__badge-sale');
      if (!heading || !compare || !badge) return;
      const savings = Math.max(0, reference - total);
      const percent = Math.round(savings / reference * 100);
      const money = cents => new Intl.NumberFormat(this.config.locale || 'en-US', {
        style: 'currency', currency: this.config.currency,
        currencyDisplay: 'symbol'
      }).format(cents / 100) + (this.config.currencyCode ? ' ' + this.config.currency : '');
      const write = (node, text) => { if (node.textContent !== text) node.textContent = text; };
      // AOV owns the actual price. Only correct the comparison and badge after its updates.
      write(compare, money(reference));
      heading.classList.toggle('price--on-sale', savings > 0);
      const text = badge.querySelector('.nowrap');
      if (text) write(text, String(this.config.badgeText || 'SAVE {percent}%')
        .replaceAll('{percent}', String(percent)).replaceAll('{amount}', money(savings)));
    }
  });
}
